<template>
  <div :class="isMobile ? 'legal-page legal-page-m' : 'legal-page'">
    <div class="legal-container">
      <router-link class="back-link" :to="{ path: '/download' }">返回下载页</router-link>
      <h1>{{ title }}</h1>
      <h2 class="document-title">{{ documentTitle }}</h2>
      <div class="meta-list">
        <p v-for="item in metaList" :key="item">{{ item }}</p>
      </div>
      <template v-for="(block, index) in blocks">
        <h2 v-if="block.type === 'section'" :key="index" class="section-title">{{ block.text }}</h2>
        <h3 v-else-if="block.type === 'subsection'" :key="index" class="subsection-title">{{ block.text }}</h3>
        <p v-else-if="block.type === 'paragraph'" :key="index" class="legal-paragraph">{{ block.text }}</p>
        <div v-else-if="block.type === 'info'" :key="index" class="info-list">
          <p v-for="item in block.items" :key="item">{{ item }}</p>
        </div>
        <ul v-else-if="block.type === 'list'" :key="index" class="legal-list">
          <li v-for="item in block.items" :key="item">{{ item }}</li>
        </ul>
      </template>
    </div>
    <a class="record-number" href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer">
      艾感科技（广东）有限公司 粤ICP备18012156号
    </a>
  </div>
</template>

<script>
export default {
  name: "PrivacyPolicy",
  data() {
    return {
      isMobile: window.innerWidth < 780,
      title: "隐私政策",
      documentTitle: "艾感智能纸尿裤助手隐私政策",
      metaList: ["发布日期：", "生效日期："],
      blocks: [
        { type: "paragraph", text: "艾感智能纸尿裤助手由运营。我们非常重视用户的个人信息和隐私保护。本隐私政策将向您说明我们如何收集、使用、存储、共享和保护您的个人信息，以及您如何管理自己的个人信息。" },
        { type: "paragraph", text: "在使用本 App 前，请您仔细阅读并充分理解本隐私政策。若您不同意本政策的任何内容，请停止使用本 App。" },
        { type: "section", text: "一、适用范围" },
        { type: "paragraph", text: "本隐私政策适用于“艾感智能纸尿裤助手”App 及相关服务。" },
        { type: "info", items: ["App 名称：艾感智能纸尿裤助手", "包名：com.aigan.smartdiaper", "官方网站/下载页面：https://www.aisensing.cn/download", "数据服务接口域名：https://fourleafpy.feelt-sport.com"] },
        { type: "paragraph", text: "上述域名均由运营或授权使用。" },
        { type: "section", text: "二、我们如何收集和使用您的信息" },
        { type: "paragraph", text: "为实现智能纸尿裤设备连接、状态查看、提醒通知和数据同步等功能，我们可能会收集和使用以下信息：" },
        { type: "subsection", text: "1. 账号及联系信息" },
        { type: "paragraph", text: "如本 App 需要注册、登录或绑定客户账号，我们可能收集：" },
        { type: "list", items: ["手机号，账号 ID，客户/机构名称，登录凭证或认证 token。"] },
        { type: "paragraph", text: "使用目的：用于账号登录、身份识别、设备绑定、客户服务和安全验证。" },
        { type: "paragraph", text: "如果本 App 不需要注册登录，请将本条改为：" },
        { type: "paragraph", text: "本 App 当前不要求用户注册账号，也不主动收集手机号、身份证号等身份信息。" },
        { type: "subsection", text: "2. 蓝牙设备信息" },
        { type: "paragraph", text: "为连接和管理智能纸尿裤相关蓝牙设备，我们可能收集：" },
        { type: "list", items: ["蓝牙设备名称", "蓝牙设备 MAC 地址或设备标识符", "设备序列号", "设备连接状态", "设备电量", "设备固件版本", "设备通信状态"] },
        { type: "paragraph", text: "使用目的：用于搜索、连接、绑定、管理智能设备，以及判断设备运行状态。" },
        { type: "subsection", text: "3. 纸尿裤及提醒相关数据" },
        { type: "paragraph", text: "为实现湿度/状态提醒、照护提示等功能，我们可能收集：" },
        { type: "list", items: ["纸尿裤状态数据", "设备检测时间", "提醒记录", "用户设置的提醒方式", "设备运行日志"] },
        { type: "paragraph", text: "使用目的：用于展示设备状态、发出提醒、排查故障和优化设备连接稳定性。" },
        { type: "paragraph", text: "请注意，如您在 App 中录入婴幼儿昵称、年龄、性别、照护记录等信息，该等信息可能涉及未成年人个人信息。请监护人谨慎填写，并确保您有权提供相关信息。" },
        { type: "subsection", text: "4. App 运行和设备信息" },
        { type: "paragraph", text: "为保障 App 正常运行和安全，我们可能收集：" },
        { type: "list", items: ["手机型号", "操作系统版本", "App 版本号", "网络类型", "崩溃日志", "操作日志", "接口请求时间", "设备权限状态"] },
        { type: "paragraph", text: "使用目的：用于故障排查、性能优化、安全风控和客户技术支持。" },
        { type: "subsection", text: "5. 网络请求信息" },
        { type: "paragraph", text: "本 App 会通过 HTTPS 与以下服务域名通信：" },
        { type: "info", items: ["https://fourleafpy.feelt-sport.com"] },
        { type: "paragraph", text: "使用目的：用于设备数据同步、账号认证、提醒服务、版本更新检查和客户支持。" },
        { type: "paragraph", text: "我们不会在 App 中故意关闭 HTTPS 证书校验，不会主动使用明文方式传输敏感信息。" },
        { type: "section", text: "三、我们申请的系统权限" },
        { type: "paragraph", text: "为实现相关功能，本 App 可能申请以下权限：" },
        { type: "subsection", text: "1. 蓝牙权限" },
        { type: "info", items: ["权限名称：", "BLUETOOTH_SCAN", "BLUETOOTH_CONNECT", "使用目的：用于搜索、连接和管理智能纸尿裤相关蓝牙设备。"] },
        { type: "subsection", text: "2. 网络权限" },
        { type: "info", items: ["权限名称：", "INTERNET", "使用目的：用于访问服务接口、同步设备数据、获取配置和进行版本检查。"] },
        { type: "subsection", text: "3. 通知权限" },
        { type: "info", items: ["权限名称：", "POST_NOTIFICATIONS", "使用目的：用于向您发送纸尿裤状态提醒、设备异常提醒和后台连接状态提醒。"] },
        { type: "subsection", text: "4. 前台服务权限" },
        { type: "info", items: ["权限名称：", "FOREGROUND_SERVICE", "使用目的：当您开启后台连接或提醒功能时，用于保持设备连接状态，并通过系统通知栏展示运行状态。"] },
        { type: "paragraph", text: "我们不会在未经您同意的情况下申请与服务无关的敏感权限。您可以在手机系统设置中关闭相关权限，但关闭后可能导致蓝牙连接、后台提醒或通知功能无法正常使用。" },
        { type: "section", text: "四、我们如何使用 Cookie 和类似技术" },
        { type: "paragraph", text: "本 App 本身。" },
        { type: "paragraph", text: "如官方网站或下载页面使用 Cookie，主要用于页面访问统计、安全防护和下载服务优化。您可以通过浏览器设置管理 Cookie。" },
        { type: "section", text: "五、我们如何共享、转让、公开披露您的信息" },
        { type: "paragraph", text: "我们不会出售您的个人信息。" },
        { type: "paragraph", text: "在以下情况下，我们可能共享必要信息：" },
        { type: "subsection", text: "1. 与客户所属企业或机构共享" },
        { type: "paragraph", text: "如本 App 为企业/客户内部分发，部分设备状态、绑定关系、故障日志可能向提供，用于设备管理、售后服务和运维支持。" },
        { type: "subsection", text: "2. 与服务提供商共享" },
        { type: "paragraph", text: "本 App 当前未接入第三方 SDK。如后续接入，我们将在本政策中更新说明。" },
        { type: "subsection", text: "3. 法律法规要求" },
        { type: "paragraph", text: "根据法律法规、监管要求、司法机关或行政机关要求，我们可能依法提供必要信息。" },
        { type: "section", text: "六、我们如何存储您的信息" },
        { type: "paragraph", text: "我们将在实现本政策所述目的所必需的期限内保存您的个人信息。" },
        { type: "info", items: ["数据存储地点：", "数据保存期限："] },
        { type: "paragraph", text: "超过保存期限后，我们将删除或匿名化处理相关信息，法律法规另有规定的除外。" },
        { type: "section", text: "七、我们如何保护您的信息" },
        { type: "paragraph", text: "我们会采取合理的安全措施保护您的个人信息，包括但不限于：" },
        { type: "list", items: ["使用 HTTPS 加密传输", "访问权限控制", "服务器安全防护", "日志留存和审计", "最小必要授权", "异常访问监控"] },
        { type: "paragraph", text: "但请您理解，互联网环境并非绝对安全。我们将尽力保护您的信息安全。" },
        { type: "section", text: "八、您如何管理个人信息" },
        { type: "paragraph", text: "您可以通过以下方式管理您的个人信息：" },
        { type: "paragraph", text: "关闭通知：您可以在手机系统设置中关闭本 App 的通知权限，也可以在 App 内“设置-提醒设置”中关闭相关提醒。" },
        { type: "paragraph", text: "关闭蓝牙权限：您可以在手机系统设置中关闭本 App 的蓝牙权限。关闭后，蓝牙扫描、设备连接和状态同步功能可能无法正常使用。" },
        { type: "paragraph", text: "如您需要访问、更正、删除个人信息，或撤回授权、注销账号，可通过以下方式联系我们：" },
        { type: "info", items: ["联系邮箱：hongying@aisensing.cn", "客服电话：0757-85335951"] },
        { type: "paragraph", text: "我们将在收到请求后个工作日内处理或答复。" },
        { type: "section", text: "九、未成年人信息保护" },
        { type: "paragraph", text: "本 App 的主要使用者应为成年人或具备完全民事行为能力的用户。" },
        { type: "paragraph", text: "如本 App 用于婴幼儿照护场景，相关婴幼儿信息应由其父母或其他监护人提供和管理。未经监护人同意，未成年人不应自行使用本 App 或提交个人信息。" },
        { type: "paragraph", text: "如您是未成年人的监护人，并认为相关未成年人信息需要查询、更正或删除，请通过本政策提供的联系方式联系我们。" },
        { type: "section", text: "十、政策更新" },
        { type: "paragraph", text: "我们可能根据业务变化、法律法规要求或产品功能调整更新本隐私政策。" },
        { type: "paragraph", text: "如更新涉及个人信息处理目的、方式、类型发生重大变化，我们会通过 App 弹窗、页面提示、下载页面公告或其他合理方式通知您。" },
        { type: "section", text: "十一、联系我们" },
        { type: "info", items: ["公司名称：艾感科技（广东）有限公司", "注册地址：佛山市禅城区张槎街道华兴路22号顺盈嘉智能科技园C座八楼C801", "联系邮箱：hongying@aisensing.cn", "客服电话：0757-85335951", "隐私负责人联系方式：18038630856"] },
        { type: "paragraph", text: "如您对本隐私政策或个人信息保护有任何疑问、投诉或建议，可以通过上述方式联系我们。" }
      ]
    }
  },
  mounted() {
    window.addEventListener("resize", this.initFunc)
  },
  destroyed() {
    window.removeEventListener("resize", this.initFunc)
  },
  methods: {
    initFunc() {
      this.isMobile = window.innerWidth < 780
    }
  }
}
</script>

<style scoped lang="less">
.legal-page {
  background: #f6f8fb;
  color: #26333d;
  padding: 40px 24px 70px;
  box-sizing: border-box;

  .legal-container {
    max-width: 960px;
    margin: 0 auto;
    padding: 38px 46px;
    background: #fff;
    border: 1px solid #e7edf3;
    border-radius: 8px;
    box-sizing: border-box;
  }

  .back-link {
    display: inline-block;
    margin-bottom: 24px;
    color: #0f8e83;
    font-size: 13px;
    line-height: 24px;
  }

  h1 {
    margin: 0 0 12px;
    color: #1d2730;
    font-size: 26px;
    line-height: 46px;
    font-weight: bold;
    text-align: left;
  }

  .document-title {
    margin: 0 0 18px;
    color: #26333d;
    font-size: 20px;
    line-height: 34px;
    font-weight: bold;
    text-align: left;
  }

  .meta-list {
    margin-bottom: 28px;
    padding-bottom: 20px;
    border-bottom: 1px solid #e7edf3;

    p {
      margin: 0 0 6px;
      color: #64727f;
      font-size: 13px;
      line-height: 24px;
      text-align: left;
    }
  }

  .section-title {
    margin: 34px 0 14px;
    color: #0f8e83;
    font-size: 20px;
    line-height: 32px;
    font-weight: bold;
    text-align: left;
  }

  .subsection-title {
    margin: 24px 0 10px;
    color: #26333d;
    font-size: 16px;
    line-height: 28px;
    font-weight: bold;
    text-align: left;
  }

  .legal-paragraph,
  .info-list p,
  .legal-list li {
    color: #3e4b56;
    font-size: 14px;
    line-height: 30px;
    text-align: left;
  }

  .legal-paragraph {
    margin: 0 0 12px;
  }

  .info-list {
    margin: 8px 0 14px;
    padding: 14px 18px;
    background: #f7fbfb;
    border-left: 3px solid #16b7a9;

    p {
      margin: 0 0 4px;
      word-break: break-word;
    }
  }

  .legal-list {
    margin: 8px 0 14px;
    padding-left: 22px;

    li {
      margin-bottom: 4px;
    }
  }

  .record-number {
    display: block;
    margin: 28px auto 0;
    padding: 0 24px;
    color: #8b97a3;
    font-size: 12px;
    line-height: 20px;
    text-align: center;
    box-sizing: border-box;
  }
}

.legal-page-m {
  padding: 0.3rem 0.24rem 1rem;

  .legal-container {
    padding: 0.48rem 0.34rem;
    border-radius: 0.12rem;
  }

  .back-link {
    margin-bottom: 0.34rem;
    font-size: 0.32rem;
    line-height: 0.48rem;
  }

  h1 {
    font-size: 0.58rem;
    line-height: 0.76rem;
  }

  .document-title {
    font-size: 0.42rem;
    line-height: 0.6rem;
  }

  .meta-list p,
  .legal-paragraph,
  .info-list p,
  .legal-list li {
    font-size: 0.32rem;
    line-height: 0.58rem;
  }

  .section-title {
    margin-top: 0.58rem;
    font-size: 0.42rem;
    line-height: 0.6rem;
  }

  .subsection-title {
    margin-top: 0.42rem;
    font-size: 0.36rem;
    line-height: 0.54rem;
  }

  .info-list {
    padding: 0.24rem 0.28rem;
  }

  .record-number {
    display: block;
    margin-top: 0.42rem;
    padding: 0 0.28rem;
    font-size: 0.24rem;
    line-height: 0.4rem;
  }
}
</style>
